// frontend\src\pages\Calculators\components\TemperatureTime\constants.js
export const FILM_TYPES = {
  BW: {
    value: 'bw',
    label: 'Чёрно-белая',
    q10: 2.0
  },
  COLOR: {
    value: 'color',
    label: 'Цветная',
    q10: 1.5
  }
};

export const DEFAULT_VALUES = {
  baseTime: 5,
  baseTemp: 20,
  targetTemp: 24
};